import _ from 'lodash';

const FRACTIONAL_PRECISION = 100;

const convertToUpperDenomination = ({
  formatDecimalPrecision = 2,
  returnType = 'float',
  value = 0
}) => {
  const parsedValue = Number(value);

  if (Number.isNaN(parsedValue)) {
    throw new Error(
      `unable to parse the value ${value}, parsing it results in NaN`
    );
  }

  const upperDenominationValue =
    parseFloat(parsedValue) / FRACTIONAL_PRECISION;

  switch (returnType.toLowerCase()) {
    case 'float':
      return parseFloat(
        upperDenominationValue.toFixed(formatDecimalPrecision)
      );
    case 'string':
      return parseFloat(upperDenominationValue).toFixed(
        formatDecimalPrecision
      );
    default:
      throw new Error('unknown returnType');
  }
};

const convertToLowerDenomination = (value) =>
  Math.round(value * FRACTIONAL_PRECISION);

export const parsePriceValueForAPI = (price) =>
  Math.round(parseFloat(convertToLowerDenomination(price)).toFixed(2));

export const parseFormatPriceValueFromAPI = (value = 0) =>
  convertToUpperDenomination({
    value,
    returnType: 'string'
  });

export const parseFormatPriceNumberValueFromAPI = (value) =>
  convertToUpperDenomination({
    value,
    returnType: 'float'
  });

const resequenceParts = (partsToResequence) => {
  const { minusSign, currency, literal } = _.keyBy(partsToResequence, 'type');
  if (minusSign && currency) {
    return [
      currency,
      literal,
      minusSign,
      ...partsToResequence.filter(
        (part) => !['currency', 'minusSign', 'literal'].includes(part.type)
      )
    ];
  }
  return partsToResequence;
};

export const convertToCurrencyFormat = ({
  roundOff = false,
  value,
  withCurrencyPrefix = true
}) => {
  const options = {
    currency: withCurrencyPrefix ? 'AED' : undefined,
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
    style: withCurrencyPrefix ? 'currency' : 'decimal'
  };

  const parsedValue = roundOff ? Math.round(value) : value;
  const formatter = new Intl.NumberFormat('en-US', options);
  let parts = formatter.formatToParts(parsedValue);

  if (withCurrencyPrefix) {
    parts = resequenceParts(parts);
  }

  return parts.map((part) => part.value).join('');
};
